/**
 * HEIGHTN — Size Chart with Foot Measurement Tool
 * 2 tabs: "Measure My Foot" + "Size Chart"
 * - Step-by-step measurement guide with input
 * - Full size chart (US / EU / UK / cm / in)
 */
(function () {
  'use strict';
  if (window.__heightnSizeGuideLoaded) return;
  window.__heightnSizeGuideLoaded = true;

  // ─── DATA ──────────────────────────────────────────────────────
  var SIZES = [
    { us: '5.5',  eu: '37',   uk: '4.5',  cm: 22.40 },
    { us: '6',    eu: '38',   uk: '5',    cm: 23.10 },
    { us: '6.5',  eu: '39',   uk: '5.5',  cm: 23.80 },
    { us: '7',    eu: '40',   uk: '6',    cm: 24.50 },
    { us: '7.5',  eu: '40.5', uk: '6.5',  cm: 24.85 },
    { us: '8',    eu: '41',   uk: '7',    cm: 25.20 },
    { us: '8.5',  eu: '41.5', uk: '7.5',  cm: 25.50 },
    { us: '8.5',  eu: '42',   uk: '7.5',  cm: 25.80 },
    { us: '9',    eu: '42.5', uk: '8',    cm: 26.15 },
    { us: '9.5',  eu: '43',   uk: '8.5',  cm: 26.50 },
    { us: '10',   eu: '43.5', uk: '9',    cm: 26.80 },
    { us: '10',   eu: '44',   uk: '9',    cm: 27.10 },
    { us: '10.5', eu: '44.5', uk: '9.5',  cm: 27.45 },
    { us: '11',   eu: '45',   uk: '10',   cm: 27.80 },
    { us: '11.5', eu: '45.5', uk: '10.5', cm: 28.10 },
    { us: '12',   eu: '46',   uk: '11',   cm: 28.40 },
    { us: '13',   eu: '47',   uk: '12',   cm: 29.30 },
    { us: '13.5', eu: '47.5', uk: '12.5', cm: 29.70 }
  ];

  function inches(cm) { return (cm / 2.54).toFixed(1); }
  function findSizeByCm(cm) {
    var best = SIZES[0], minDiff = Infinity;
    SIZES.forEach(function (s) {
      var d = Math.abs(s.cm - cm);
      if (d < minDiff) { minDiff = d; best = s; }
    });
    return best;
  }

  // ─── CSS ───────────────────────────────────────────────────────
  function injectCss() {
    if (document.getElementById('hg-sg-styles')) return;
    var s = document.createElement('style');
    s.id = 'hg-sg-styles';
    s.textContent = [
      /* Variant picker styling */
      'fieldset.variant-option--buttons{display:grid !important;grid-template-columns:repeat(5,1fr) !important;gap:5px !important}',
      'fieldset.variant-option--buttons legend{grid-column:1/-1 !important;display:flex !important;justify-content:space-between !important;align-items:center !important;width:100% !important;margin-bottom:8px !important}',
      '.variant-option__button-label{min-width:unset !important;width:100% !important;height:36px !important;padding:0 !important;margin:0 !important;display:flex !important;align-items:center !important;justify-content:center !important;border:0.8px solid #d0d0d0 !important;border-radius:var(--style-border-radius-buttons-primary) !important;background:#fff !important;cursor:pointer !important;box-shadow:none !important}',
      '.variant-option__button-label__text{font-size:12px !important;font-weight:500 !important;color:#222 !important;line-height:1 !important}',
      '.variant-option__button-label:has(input:checked){background:#111 !important;border-color:#111 !important}',
      '.variant-option__button-label:has(input:checked) .variant-option__button-label__text{color:#fff !important}',
      '.variant-option__button-label:has(input[data-option-available="false"]){background:#f5f5f5 !important;border-color:#e5e5e5 !important;cursor:default !important}',
      '.variant-option__button-label:has(input[data-option-available="false"]) .variant-option__button-label__text{color:#b0b0b0 !important;text-decoration:line-through !important}',

      /* Size Chart link */
      '.hg-sg-link{display:inline-flex;align-items:center;padding:0;margin:0 0 0 auto;background:none;border:none;cursor:pointer;font-size:11px;font-weight:500;color:#111;text-decoration:underline;text-underline-offset:3px;text-decoration-thickness:1px;line-height:1;white-space:nowrap;font-family:inherit;-webkit-appearance:none;appearance:none;flex-shrink:0}',
      '.hg-sg-link:hover{opacity:.65}',

      /* Modal */
      '.hg-sg-overlay{position:fixed;inset:0;z-index:999999;background:rgba(0,0,0,.55);backdrop-filter:blur(3px);display:flex;align-items:center;justify-content:center;padding:16px;opacity:0;transition:opacity .2s ease;font-family:inherit}',
      '.hg-sg-overlay.open{opacity:1}',
      '.hg-sg-modal{background:#fff;border-radius:16px;width:100%;max-width:440px;max-height:88vh;overflow:auto;padding:28px;box-shadow:0 24px 60px rgba(0,0,0,.28);transform:translateY(10px) scale(.97);transition:transform .28s cubic-bezier(.16,1,.3,1);position:relative}',
      '.hg-sg-overlay.open .hg-sg-modal{transform:translateY(0) scale(1)}',
      '.hg-sg-close{position:absolute;top:14px;right:14px;background:none;border:none;cursor:pointer;font-size:24px;line-height:1;color:#999;padding:4px;z-index:2;display:flex;align-items:center;justify-content:center}',
      '.hg-sg-close:hover{color:#111}',
      '.hg-sg-title{font-size:18px;font-weight:700;color:#111;margin:0 0 20px;text-align:center}',

      /* Tabs */
      '.hg-sg-tabs{display:flex;border-bottom:1.5px solid #ebebeb;margin-bottom:20px;gap:4px}',
      '.hg-sg-tab{flex:1;background:none;border:none;padding:12px 8px;font-size:12px;font-weight:600;color:#888;cursor:pointer;border-bottom:2px solid transparent;margin-bottom:-1.5px;font-family:inherit;letter-spacing:.02em;transition:color .15s}',
      '.hg-sg-tab:hover{color:#444}',
      '.hg-sg-tab.active{color:#111;border-bottom-color:#111}',

      /* Foot SVG */
      '.hg-sg-foot{display:block;margin:0 auto 12px;width:130px;height:auto}',

      /* Steps */
      '.hg-sg-steps{list-style:none;padding:0;margin:0 0 18px;display:flex;flex-direction:column;gap:12px}',
      '.hg-sg-step{display:flex;gap:12px;align-items:flex-start}',
      '.hg-sg-step-num{flex-shrink:0;width:26px;height:26px;border-radius:50%;background:#111;color:#fff;display:flex;align-items:center;justify-content:center;font-size:11px;font-weight:800}',
      '.hg-sg-step-text{font-size:13px;color:#444;line-height:1.55;padding-top:3px}',
      '.hg-sg-step-text b{color:#111}',

      /* Input + button */
      '.hg-sg-input-row{display:flex;gap:8px;margin-bottom:14px}',
      '.hg-sg-input{flex:1;border:1px solid #d0d0d0;border-radius:8px;padding:0 14px;height:44px;font-size:14px;font-family:inherit;outline:none;color:#111}',
      '.hg-sg-input:focus{border-color:#111}',
      '.hg-sg-select{border:1px solid #d0d0d0;border-radius:8px;padding:0 12px;height:44px;font-size:14px;font-family:inherit;background:#fff;cursor:pointer;color:#111}',
      '.hg-sg-btn{width:100%;height:44px;border:none;border-radius:8px;background:#111;color:#fff;font-size:14px;font-weight:700;cursor:pointer;font-family:inherit;transition:opacity .15s}',
      '.hg-sg-btn:hover:not(:disabled){opacity:.85}',
      '.hg-sg-btn:disabled{opacity:.4;cursor:not-allowed}',

      /* Result */
      '.hg-sg-result{background:linear-gradient(135deg,#0a0a0a,#1f1f1f);color:#fff;border-radius:14px;padding:22px;text-align:center;margin-top:16px}',
      '.hg-sg-result-label{font-size:11px;font-weight:700;letter-spacing:.08em;text-transform:uppercase;color:#aaa;margin-bottom:8px}',
      '.hg-sg-result-num{font-size:44px;font-weight:800;line-height:1;margin-bottom:6px}',
      '.hg-sg-result-sub{font-size:13px;color:#bbb}',

      /* Table */
      '.hg-sg-table{width:100%;border-collapse:collapse;font-size:13px}',
      '.hg-sg-table th{font-size:10px;font-weight:800;color:#888;text-transform:uppercase;letter-spacing:.06em;text-align:left;padding:10px 8px;border-bottom:1.5px solid #e5e5e5;background:#fafafa}',
      '.hg-sg-table td{padding:10px 8px;border-bottom:1px solid #f0f0f0;color:#333}',
      '.hg-sg-table tbody tr{transition:background .12s}',
      '.hg-sg-table tbody tr:hover{background:#fafafa}'
    ].join('');
    document.head.appendChild(s);
  }

  // ─── MODAL ─────────────────────────────────────────────────────
  var overlayEl = null;
  var tab = 'measure';

  function openModal() {
    if (overlayEl) return;
    overlayEl = document.createElement('div');
    overlayEl.className = 'hg-sg-overlay';
    overlayEl.innerHTML = '<div class="hg-sg-modal" role="dialog" aria-modal="true"></div>';
    document.body.appendChild(overlayEl);
    document.body.style.overflow = 'hidden';
    tab = 'measure';
    render();
    requestAnimationFrame(function () { overlayEl.classList.add('open'); });
    overlayEl.addEventListener('click', function (e) {
      if (e.target === overlayEl) closeModal();
    });
    document.addEventListener('keydown', escClose);
  }

  function closeModal() {
    if (!overlayEl) return;
    overlayEl.classList.remove('open');
    document.removeEventListener('keydown', escClose);
    var ref = overlayEl;
    overlayEl = null;
    setTimeout(function () {
      if (ref.parentNode) ref.remove();
      document.body.style.overflow = '';
    }, 220);
  }

  function escClose(e) { if (e.key === 'Escape') closeModal(); }

  function render() {
    var content = '';
    if (tab === 'measure') {
      content =
        '<svg class="hg-sg-foot" viewBox="0 0 140 230" fill="none" aria-hidden="true">' +
          /* Foot outline — natural anatomy: narrow toes → wide ball → slight arch → rounded heel */
          '<path d="M50 10 C30 10 22 26 22 52 C22 78 26 104 24 134 C22 164 28 194 38 209 C44 216 50 217 50 217 C50 217 56 216 62 209 C72 194 78 164 76 134 C74 104 78 78 78 52 C78 26 70 10 50 10 Z" fill="#fafafa" stroke="#111" stroke-width="2" stroke-linejoin="round"/>' +
          /* Heel and toe markers */
          '<circle cx="50" cy="13" r="3" fill="#111"/>' +
          '<circle cx="50" cy="214" r="3" fill="#111"/>' +
          /* Dashed extension lines */
          '<line x1="82" y1="13" x2="104" y2="13" stroke="#bbb" stroke-width="1" stroke-dasharray="2,2"/>' +
          '<line x1="82" y1="214" x2="104" y2="214" stroke="#bbb" stroke-width="1" stroke-dasharray="2,2"/>' +
          /* Measurement arrow */
          '<line x1="98" y1="22" x2="98" y2="205" stroke="#111" stroke-width="1.5"/>' +
          '<polygon points="93,22 98,13 103,22" fill="#111"/>' +
          '<polygon points="93,205 98,214 103,205" fill="#111"/>' +
        '</svg>' +
        '<ol class="hg-sg-steps">' +
          '<li class="hg-sg-step"><span class="hg-sg-step-num">1</span><span class="hg-sg-step-text">Stand on a piece of paper with your <b>heel against a wall</b>.</span></li>' +
          '<li class="hg-sg-step"><span class="hg-sg-step-num">2</span><span class="hg-sg-step-text">Mark the tip of your <b>longest toe</b> with a pencil.</span></li>' +
          '<li class="hg-sg-step"><span class="hg-sg-step-num">3</span><span class="hg-sg-step-text">Measure from the wall to the mark in <b>cm or inches</b>.</span></li>' +
          '<li class="hg-sg-step"><span class="hg-sg-step-num">4</span><span class="hg-sg-step-text">Enter the measurement below to find your size.</span></li>' +
        '</ol>' +
        '<div class="hg-sg-input-row">' +
          '<input type="number" class="hg-sg-input" id="hg-sg-foot-in" placeholder="Enter foot length" step="0.1" min="20" max="35" inputmode="decimal"/>' +
          '<select class="hg-sg-select" id="hg-sg-unit"><option value="cm" selected>cm</option><option value="in">in</option></select>' +
        '</div>' +
        '<button class="hg-sg-btn" id="hg-sg-find" disabled>Find My Size</button>' +
        '<div id="hg-sg-result-slot"></div>';
    } else {
      var rows = SIZES.map(function (s) {
        return '<tr>' +
          '<td><b>' + s.eu + '</b></td>' +
          '<td>' + s.uk + '</td>' +
          '<td>' + s.us + '</td>' +
          '<td>' + s.cm.toFixed(1) + ' cm</td>' +
          '<td>' + inches(s.cm) + '"</td>' +
        '</tr>';
      }).join('');
      content =
        '<table class="hg-sg-table">' +
          '<thead><tr><th>EU</th><th>UK</th><th>US</th><th>cm</th><th>in</th></tr></thead>' +
          '<tbody>' + rows + '</tbody>' +
        '</table>';
    }

    var html =
      '<button class="hg-sg-close" aria-label="Close">&times;</button>' +
      '<p class="hg-sg-title">Find Your Perfect Fit</p>' +
      '<div class="hg-sg-tabs">' +
        '<button class="hg-sg-tab' + (tab === 'measure' ? ' active' : '') + '" data-tab="measure">Measure My Foot</button>' +
        '<button class="hg-sg-tab' + (tab === 'chart' ? ' active' : '') + '" data-tab="chart">Size Chart</button>' +
      '</div>' +
      content;

    overlayEl.querySelector('.hg-sg-modal').innerHTML = html;

    overlayEl.querySelector('.hg-sg-close').addEventListener('click', closeModal);
    overlayEl.querySelectorAll('[data-tab]').forEach(function (b) {
      b.addEventListener('click', function () {
        tab = b.dataset.tab;
        render();
      });
    });

    var inp = overlayEl.querySelector('#hg-sg-foot-in');
    var btn = overlayEl.querySelector('#hg-sg-find');
    var unitSel = overlayEl.querySelector('#hg-sg-unit');
    if (inp && btn && unitSel) {
      inp.addEventListener('input', function () { btn.disabled = !inp.value; });
      inp.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' && !btn.disabled) btn.click();
      });
      /* Adjust min/max when unit changes */
      unitSel.addEventListener('change', function () {
        if (unitSel.value === 'in') {
          inp.min = '8'; inp.max = '14';
        } else {
          inp.min = '20'; inp.max = '35';
        }
      });
      btn.addEventListener('click', function () {
        var val = parseFloat(inp.value);
        if (!val) return;
        var cm = unitSel.value === 'in' ? val * 2.54 : val;
        var best = findSizeByCm(cm);
        overlayEl.querySelector('#hg-sg-result-slot').innerHTML =
          '<div class="hg-sg-result">' +
            '<div class="hg-sg-result-label">Your recommended size</div>' +
            '<div class="hg-sg-result-num">EU ' + best.eu + '</div>' +
            '<div class="hg-sg-result-sub">UK ' + best.uk + ' · US ' + best.us + '</div>' +
            '<div class="hg-sg-result-sub" style="margin-top:6px;opacity:.7">Foot length ' + best.cm.toFixed(1) + ' cm · ' + inches(best.cm) + '"</div>' +
          '</div>';
      });
    }
  }

  // ─── INJECT LINK ───────────────────────────────────────────────
  function injectLink() {
    var legends = Array.prototype.slice.call(document.querySelectorAll('fieldset.variant-option--buttons')).filter(function (f) {
      var r = f.querySelector('input[type="radio"]');
      return r && /^Size-/.test(r.name);
    }).map(function (f) { return f.querySelector('legend'); }).filter(Boolean);
    legends.forEach(function (legend) {
      if (legend.querySelector('[data-hg-sg]')) return;
      var link = document.createElement('button');
      link.type = 'button';
      link.className = 'hg-sg-link';
      link.setAttribute('data-hg-sg', '');
      link.setAttribute('aria-label', 'Open size chart');
      link.textContent = 'Size Chart';
      legend.appendChild(link);
      link.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        openModal();
      });
    });
  }

  function init() {
    injectCss();
    injectLink();
    new MutationObserver(function () { injectLink(); })
      .observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
